"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageModal = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../common/js/helper/translation");
const MessageModal = (props) => {
    const { title, body, onDone, onCancel } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "modal-header znd-modal__header znd-sales-channel-deactivated-modal__header" },
            react_1.default.createElement("h3", { className: "znd-modal__title znd-sales-channel-deactivated-modal__title" }, title)),
        react_1.default.createElement("div", { className: "modal-body znd-modal__body", dangerouslySetInnerHTML: { __html: body } }),
        react_1.default.createElement("div", { className: "modal-footer znd-modal__footer znd-sales-channel-deactivated-modal__footer" },
            react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: onCancel }),
            react_1.default.createElement(Button_1.default, { className: "znd-message-modal__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('message_modal.apply'), onClick: onDone }))));
};
exports.MessageModal = MessageModal;
exports.default = exports.MessageModal;
